export default __webpack_public_path__ + "static/media/Nike Blazer Mid ‘77 vintage.69437984.jpg";